import { useEffect } from "react";
import { useAccessibility } from "../core/useAccessibility";

export function ReducedMotionManager() {
  const { state, setReduceMotion } = useAccessibility();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

    // Initial sync (only if user didn't choose manually)
    if (mediaQuery.matches && state.reduceMotion === false) {
      setReduceMotion(true);
    }

    const handler = (e: MediaQueryListEvent) => {
      // Only auto-apply if user didn't explicitly set preference
      if (state.userOverrideReduceMotion) return;

      setReduceMotion(e.matches);
    };

    mediaQuery.addEventListener("change", handler);

    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, [state.userOverrideReduceMotion]);

  return null;
}
